module.exports = __webpack_public_path__ + "images/site_cagespace_icon.21bc7974.png";